import { Trans, useTranslation } from "react-i18next";
import { FaCar } from "react-icons/fa6";

import { cn } from "../../../../utils/classnames";
import { createTypographyHelper } from "../../../../utils/typography";
import LazyImage from "../../../../components/common/LazyImage";
import { NaritaAirport } from "../../../front-pages/maps/components/NaritaAirport";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "../../../../components/icons";

const AlphardImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/services/alphard.png";

function NaritaAirportTransfer() {
  const { t, i18n } = useTranslation();
  const isJapanese = i18n.language === "jp";
  const getTypographyClass = createTypographyHelper(i18n.language);

  return (
    <div>
      {/* Intro Description */}
      <div className="tw:mb-12 tw:lg:mb-[68px] tw:px-5 tw:lg:px-[82px]">
        <div
          className={cn(
            "tw:text-[#282828] tw:font-hanken-grotesk",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
          dangerouslySetInnerHTML={{
            __html: t("AirportTransfer.NaritaAirportTransfer.Description"),
          }}
        />
      </div>

      {/* Airport Map Section */}
      <div className="tw:mb-8 tw:lg:mb-[68px]">
        <div className="tw:mb-6 tw:lg:mb-8 tw:px-5 tw:lg:px-[82px]">
          <div className={cn("tw:text-[#282828] tw:font-libre-caslon-display tw:mb-6 tw:lg:mb-6", isJapanese ? "tw:text-[22px] tw:leading-[26px]" : "tw:lg:text-[26px] tw:lg:leading-[35px]")}>
            {t("AirportTransfer.NaritaAirportTransfer.Map.Title")}
          </div>
          <div
            className={cn(
              "tw:text-[#282828] tw:font-hanken-grotesk",
              getTypographyClass(13),
              getTypographyClass(14, "lg")
            )}
          >
            <Trans
              i18nKey="AirportTransfer.NaritaAirportTransfer.Map.Description"
              components={{
                strong: <strong className="tw:font-bold" />,
              }}
            />
          </div>
        </div>

        {/* Terminal Maps - Using existing component */}
        <div className="tw:px-5 tw:lg:px-[82px]">
          <NaritaAirport />
        </div>
      </div>

      {/* About Airport Transfer Service */}
      <div className="tw:mb-8 tw:lg:mb-[68px]">
        <div className={cn("tw:px-5 tw:lg:px-[82px] tw:text-[#282828] tw:font-libre-caslon-display tw:mb-6 tw:lg:mb-8", isJapanese ? "tw:text-[22px] tw:leading-[26px]" : "tw:lg:text-[26px] tw:lg:leading-[35px]")}>
          {t("AirportTransfer.NaritaAirportTransfer.About.Title")}
        </div>

        <div className="tw:bg-[#f9f9f9] tw:rounded-[10px] tw:px-5 tw:lg:px-[68px] tw:py-8 tw:lg:py-[54px] tw:space-y-6 tw:lg:space-y-[54px]">
          {/* Airport Meet & Assist Service */}
          <div className="tw:flex tw:flex-col tw:lg:flex-row tw:gap-5 tw:lg:gap-[154px]">
            <div className="tw:lg:min-w-[200px] tw:lg:w-[200px]">
              <div className="tw:text-[#282828] tw:font-hanken-grotesk tw:font-medium tw:lg:font-semibold tw:text-[16px] tw:lg:text-[18px] tw:lg:leading-[25px]">
                {t("AirportTransfer.NaritaAirportTransfer.About.AirportMeetAssistService.Title")}
              </div>
            </div>
            <div className="tw:flex-1">
              <div
                className={cn(
                  "tw:text-[#282828] tw:font-hanken-grotesk tw:whitespace-pre-wrap",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey="AirportTransfer.NaritaAirportTransfer.About.AirportMeetAssistService.Description"
                  components={{
                    strong: <strong className="tw:font-bold" />,
                  }}
                />
              </div>
            </div>
          </div>

          <div className="tw:h-px tw:bg-[#f1f1f1]" />

          {/* Corporate Welcome Options */}
          <div className="tw:flex tw:flex-col tw:lg:flex-row tw:gap-5 tw:lg:gap-[154px]">
            <div className="tw:lg:min-w-[200px] tw:lg:w-[200px]">
              <div className="tw:text-[#282828] tw:font-hanken-grotesk tw:font-medium tw:lg:font-semibold tw:text-[16px] tw:lg:text-[18px] tw:lg:leading-[25px]">
                {t("AirportTransfer.NaritaAirportTransfer.About.CorporateWelcome.Title")}
              </div>
            </div>
            <div className="tw:flex-1">
              <div
                className={cn(
                  "tw:text-[#282828] tw:font-hanken-grotesk tw:whitespace-pre-wrap",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey="AirportTransfer.NaritaAirportTransfer.About.CorporateWelcome.Description"
                  components={{
                    strong: <strong className="tw:font-bold" />,
                  }}
                />
              </div>
            </div>
          </div>

          <div className="tw:h-px tw:bg-[#f1f1f1]" />

          {/* Vehicle Comfort & Amenities */}
          <div className="tw:flex tw:flex-col tw:lg:flex-row tw:gap-5 tw:lg:gap-[154px]">
            <div className="tw:lg:min-w-[200px] tw:lg:w-[200px]">
              <div className="tw:text-[#282828] tw:font-hanken-grotesk tw:font-medium tw:lg:font-semibold tw:text-[16px] tw:lg:text-[18px] tw:lg:leading-[25px]">
                {t("AirportTransfer.NaritaAirportTransfer.About.VehicleComfort.Title")}
              </div>
            </div>
            <div className="tw:flex-1 tw:flex tw:flex-col tw:lg:flex-row tw:gap-4 tw:lg:gap-[45px]">
              <div
                className={cn(
                  "tw:text-[#282828] tw:font-hanken-grotesk tw:whitespace-pre-wrap tw:flex-1",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey="AirportTransfer.NaritaAirportTransfer.About.VehicleComfort.Description"
                  components={{
                    strong: <strong className="tw:font-bold" />,
                  }}
                />
              </div>
              <div className="tw:flex tw:flex-col tw:gap-3 tw:lg:w-[351px]">
                <div className="tw:px-[45px]">
                  <LazyImage
                    src={AlphardImage}
                    alt="Toyota Alphard"
                    wrapperClassName="tw:w-full tw:lg:h-[150px] tw:rounded-[5px] tw:overflow-hidden"
                    className="tw:w-full tw:h-full tw:object-cover"
                  />
                </div>
                <Link to="/fleet" className="tw:bg-white tw:border tw:border-[#f1f1f1] tw:rounded-[5px] tw:h-[50px] tw:px-4 tw:flex tw:items-center tw:justify-between tw:!text-[#4e4e4e] tw:font-hanken-grotesk tw:font-bold tw:text-[15px] tw:leading-[22px] tw:transition-colors tw:hover:bg-gray-50 tw:!no-underline">
                  <div className="tw:flex tw:items-center tw:gap-2">
                    <FaCar size={20} color="#4E4E4E" />
                    {t("AirportTransfer.OurFleets")}
                  </div>
                  <ArrowRightIcon color="#4A4A4A" size={24} />
                </Link>
              </div>
            </div>
          </div>

          <div className="tw:h-px tw:bg-[#f1f1f1]" />

          {/* Multi-lingual Chauffeur Support */}
          <div className="tw:flex tw:flex-col tw:lg:flex-row tw:gap-5 tw:lg:gap-[154px]">
            <div className="tw:lg:min-w-[200px] tw:lg:w-[200px]">
              <div className="tw:text-[#282828] tw:font-hanken-grotesk tw:font-medium tw:lg:font-semibold tw:text-[16px] tw:lg:text-[18px] tw:lg:leading-[25px]">
                {t("AirportTransfer.NaritaAirportTransfer.About.MultilingualSupport.Title")}
              </div>
            </div>
            <div className="tw:flex-1">
              <div
                className={cn(
                  "tw:text-[#282828] tw:font-hanken-grotesk tw:whitespace-pre-wrap",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey="AirportTransfer.NaritaAirportTransfer.About.MultilingualSupport.Description"
                  components={{
                    strong: <strong className="tw:font-bold" />,
                  }}
                />
              </div>
            </div>
          </div>

          <div className="tw:h-px tw:bg-[#f1f1f1]" />

          {/* Commitment to Seamless Service */}
          <div className="tw:flex tw:flex-col tw:lg:flex-row tw:gap-5 tw:lg:gap-[154px]">
            <div className="tw:lg:min-w-[200px] tw:lg:w-[200px]">
              <div className="tw:text-[#282828] tw:font-hanken-grotesk tw:font-medium tw:lg:font-semibold tw:text-[16px] tw:lg:text-[18px] tw:lg:leading-[25px]">
                {t("AirportTransfer.NaritaAirportTransfer.About.SeamlessService.Title")}
              </div>
            </div>
            <div className="tw:flex-1">
              <div
                className={cn(
                  "tw:text-[#282828] tw:font-hanken-grotesk tw:whitespace-pre-wrap",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                <Trans
                  i18nKey="AirportTransfer.NaritaAirportTransfer.About.SeamlessService.Description"
                  components={{
                    strong: <strong className="tw:font-bold" />,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Terms & Conditions */}
      <div className="tw:mb-8 tw:lg:mb-[68px] tw:px-5 tw:lg:px-[82px]">
        <div className={cn("tw:text-[#282828] tw:font-libre-caslon-display tw:mb-4 tw:lg:mb-6", isJapanese ? "tw:text-[22px] tw:leading-[26px]" : "tw:lg:text-[26px] tw:lg:leading-[35px]")}>
          {t("AirportTransfer.NaritaAirportTransfer.Terms.Title")}
        </div>
        <div
          className={cn(
            "tw:text-[#282828] tw:font-hanken-grotesk tw:space-y-1",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          {(() => {
            const items = t("AirportTransfer.NaritaAirportTransfer.Terms.Items", { returnObjects: true });
            if (Array.isArray(items)) {
              return items.map((item, index) => <div key={index}>{item}</div>);
            }
            return null;
          })()}
        </div>
      </div>
    </div>
  );
}

export default NaritaAirportTransfer;
